import { connect } from 'react-redux';
import { submit, change as changeFormValue } from 'redux-form';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { constants } from '@eti/utils';
import { CHECK_IN_BAGGAGE } from '../../../products';
import CheckInBaggagePrimaryFlowPersuasionModal from '../components/CheckInBaggagePrimaryFlowPersuasionModal';
import PersuasionModalProvider from '../../../common/context/PersuasionModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
const productName = CHECK_IN_BAGGAGE.name;
const setCheckedBaggageChoiceValueForTraveler = (dispatch, {
  sellSpecification
}) => (form, traveler, value) => {
  var _sellSpecification$se, _sellSpecification$se2;
  const {
    id,
    markup,
    price
  } = traveler;
  const {
    options = []
  } = (_sellSpecification$se = sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$se2 = sellSpecification.sellPriceBaggage) === null || _sellSpecification$se2 === void 0 ? void 0 : _sellSpecification$se2[0]) !== null && _sellSpecification$se !== void 0 ? _sellSpecification$se : {};
  const {
    numberOfUnits,
    weight,
    weightUnit
  } = options[0] || {};
  const formattedValue = value === 'true';
  dispatch(changeFormValue(form, `${productName}.${productName}-traveler-${id}`, {
    value,
    id,
    markup: formattedValue ? markup : null,
    priceRaw: formattedValue ? price !== null && price !== void 0 ? price : 0 : 0,
    numberOfPieces: numberOfUnits,
    weight,
    weightUnit
  }));
};
const PersuasionModalWrapper = ({
  submitForm,
  triggerChange
}) => /*#__PURE__*/_jsx(PersuasionModalProvider, {
  children: /*#__PURE__*/_jsx(CheckInBaggagePrimaryFlowPersuasionModal, {
    submitForm: submitForm,
    triggerChange: triggerChange
  })
});
const triggerChange = (dispatch, props) => value => {
  const {
    form,
    sellSpecification,
    shouldApplySelectionToAll,
    order
  } = props;
  if (shouldApplySelectionToAll) {
    order === null || order === void 0 || order.travelers.forEach(traveler => {
      const isTravelerInfant = traveler.ageType === constants.ageTypes.INFANT;
      if (!isTravelerInfant) {
        setCheckedBaggageChoiceValueForTraveler(dispatch, {
          sellSpecification
        })(form, traveler, value);
      }
    });
  }
};
const mapDispatchToProps = (dispatch, props) => {
  const {
    form,
    sellSpecification,
    shouldApplySelectionToAll,
    order
  } = props;
  return {
    triggerChange: triggerChange(dispatch, {
      form,
      sellSpecification,
      shouldApplySelectionToAll,
      order
    }),
    submitForm() {
      dispatch(submit(form));
    }
  };
};
export default connect(null, mapDispatchToProps)(PersuasionModalWrapper);
//# sourceMappingURL=CheckInBaggagePrimaryFlowPersuasionModalContainer.js.map